import { SalesManagerService } from '@/services/sales-manager.service'
import Config from '@/thirdParty/config'
export default {
  methods: {
    async getListService() {
      try {
        const dataConfigService = []
        const response = await SalesManagerService.getGroupService({})
        if (response.code === 1000) {
          const dataGroupService = response.data.groupService
          const data = dataGroupService.filter(e => e.service === 'SELL')
          if (data[0].detail.length > 0) {
            data[0].detail.map(e => {
              const body = {
                id: e.code,
                text: this.serviceTypes(e.name),
              }
              dataConfigService.push(body)
            })
          }
        }
        return dataConfigService
      } catch (error) {
        console.log(error)
      }
    },
    serviceTypes(itemm) {
      const listServiceTypes = Config.listServiceTypes
      return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
    },
  },
}
